<ui-section
	title="Guarantors"
	[isEmpty]="(zeroGuarantors$ | async) && !showAddGuarantor"
	emptyMessage="There are no Guarantors in this file."
>
	<ui-button
		*ngIf="_allowAddEdit"
		title-action
		(click)="_allowAddEdit && toggleShowSearchGuarantor()"
		label="Add"
		icon="plus"
		preset="MEDIUM_EMPHASIS"
	/>

	<div class="flex flex-col w-full" section-content>
		<app-matter-user-select-or-search
			*ngIf="showAddGuarantor && _allowAddEdit"
			[@openClose]
			[showMatterClientTypes]="[clientGuarantorTypes.GUARANTOR]"
			(selectedCurrent)="addGuarantor($event)"
			(selectedAddClient)="addGuarantor($event)"
			(selectedCreateClient)="createGuarantor($event)"
		/>

		<div
			*ngFor="let guarantor of guarantors$ | async"
			class="mt-2 flex flex-col gap-3"
		>
			<app-container>
				<atomic-party-client-card
					[client]="guarantor"
					[hasCheckboxes]="false"
					[kebabOptions]="clientKebabOptions"
					(onKebabSelect)="onKebabSelect(guarantor.id, $event)"
				/>
			</app-container>
		</div>
	</div>
</ui-section>
